import React from "react";
import TablaServicios from "../../components/servicios/TablaServicios";

const ServiciosSection = () => {
    return (
      <div>
        <TablaServicios />
      </div>
    );
  };
  
  export default ServiciosSection;
  